"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockMenuItems = void 0;
var mockMenuItems = [{
  calories: 0,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: '',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_CustomBanner',
    imageURL: 'https://lcemedia.littlecaesars.com/custompizza/CYO_RegLg.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 0,
  itemCaloriesText: '',
  itemDescription: '',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Create Your Own Pizza',
  itemName: 'Create Your Own Pizza',
  itemType: 'CUS',
  maxToppings: 0,
  menuItemCode: 'BNR-CUS',
  menuWarnings: null,
  orderable: true,
  price: 0,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 3000,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/fbf13920-e9b1-4024-8788-5ee19c820e78.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/fbf13920-e9b1-4024-8788-5ee19c820e78.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201342,
  itemCaloriesText: '3000 Cal',
  itemDescription: 'Four slices of Pepperoni pizza combined with eight Italian Cheese Stix, plus Crazy Sauce®',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Slices-N-Stix® (3000 Cal)',
  itemName: 'Slices-N-Stix®',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-SNS',
  menuWarnings: null,
  orderable: true,
  price: 6.5,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2130,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/95bc83b8-396c-453a-b306-8311931de036.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/95bc83b8-396c-453a-b306-8311931de036.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201100,
  itemCaloriesText: '2130 Cal',
  itemDescription: 'Large thin crust pizza topped right to the edge with Pepperoni and Cheese.',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Thin Crust Pepperoni (2130 Cal)',
  itemName: 'Thin Crust Pepperoni',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-TPEP',
  menuWarnings: null,
  orderable: true,
  price: 7.49,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 1980,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d42e7dcb-ea78-45ef-b31b-61bc94929db0.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/d42e7dcb-ea78-45ef-b31b-61bc94929db0.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201108,
  itemCaloriesText: '1980 Cal',
  itemDescription: 'Large thin crust pizza topped right to the edge with Cheese.',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Thin Crust Cheese (1980 Cal)',
  itemName: 'Thin Crust Cheese',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'HNR-THINCHS',
  menuWarnings: null,
  orderable: true,
  price: 7.49,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2980,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/079c3f2b-3b20-4f81-a675-4f9a921f2e4e.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/079c3f2b-3b20-4f81-a675-4f9a921f2e4e.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201138,
  itemCaloriesText: '2980 Cal',
  itemDescription: 'Large round pizza with more Pepperoni and Cheese than our Classic pizza baked into the crust.',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Stuffed Crust Pepperoni (2980 Cal)',
  itemName: 'Stuffed Crust Pepperoni',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-SCPEP',
  menuWarnings: null,
  orderable: true,
  price: 9,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 3340,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/bce6b83b-f0e8-4ed0-8f15-74fefcf5a961.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/bce6b83b-f0e8-4ed0-8f15-74fefcf5a961.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 101229,
  itemCaloriesText: '3340 Cal',
  itemDescription: 'A large ExtraMostBestest® pepperoni pizza with pepperoni and cheese stuffed in a parmesa.',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Pepperoni & Cheese Stuffed Crust (3340 Cal)',
  itemName: 'Pepperoni & Cheese Stuffed Crust',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-PCSCPEP',
  menuWarnings: null,
  orderable: true,
  price: 10,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2830,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/90c26a69-f3bc-45b7-b845-0076e9b36a80.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/90c26a69-f3bc-45b7-b845-0076e9b36a80.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201150,
  itemCaloriesText: '2830 Cal',
  itemDescription: 'CRAZY!CRAZY!™ AMOUNTS OF Sausage, Smoky Ham, Pepperoni and Seasoned Beef',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: '5 Meat Feast™ (2830 Cal)',
  itemName: '5 Meat Feast™',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-5MFP',
  menuWarnings: null,
  orderable: true,
  price: 9,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2510,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/676b0279-baf7-4cac-8b79-e5b43794263c.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/676b0279-baf7-4cac-8b79-e5b43794263c.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201004,
  itemCaloriesText: '2510 Cal',
  itemDescription: 'CRAZY!CRAZY!™ AMOUNT Pepperoni, Italian Sausage, Mushrooms, Onions, and Green Peppers',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Ultimate Supreme (2510 Cal)',
  itemName: 'Ultimate Supreme',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-USP',
  menuWarnings: null,
  orderable: true,
  price: 8,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2870,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/ddb6c649-0722-41d3-a267-c98ed7ec0990.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/ddb6c649-0722-41d3-a267-c98ed7ec0990.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201003,
  itemCaloriesText: '2870 Cal',
  itemDescription: 'CRAZY!CRAZY!™ AMOUNTS OF TOPPINGS AT THE NATION Pepperoni, Italian Sausage and Bacon',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: '3 Meat Treat® (2870 Cal)',
  itemName: '3 Meat Treat®',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-3MT',
  menuWarnings: null,
  orderable: true,
  price: 8,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2180,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/54825eb3-5d4e-46e0-a821-df3e352d247b.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/54825eb3-5d4e-46e0-a821-df3e352d247b.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201002,
  itemCaloriesText: '2180 Cal',
  itemDescription: 'CRAZY!CRAZY!™ AMOUNTS OF TOPPINGS am and Pineapple',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Hula Hawaiian® (2180 Cal)',
  itemName: 'Hula Hawaiian®',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-HHP',
  menuWarnings: null,
  orderable: true,
  price: 10,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2240,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/70d38673-402a-433a-9127-79c8da501062.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/70d38673-402a-433a-9127-79c8da501062.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201008,
  itemCaloriesText: '2240 Cal',
  itemDescription: 'CRAZY!CRAZY!™ AMOUNTS OF TOPnd pizza with Green Peppers, Onions, Mushroom Seasoning',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Veggie (2240 Cal)',
  itemName: 'Veggie',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-VEGP',
  menuWarnings: null,
  orderable: true,
  price: 8,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2220,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/4de86567-b9e3-4820-a177-9a84facbca8e.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/4de86567-b9e3-4820-a177-9a84facbca8e.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201128,
  itemCaloriesText: '2220 Cal',
  itemDescription: 'Large round pizza with more Cheese than our Classic pizza.',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'ExtraMostBestest® Cheese (2220 Cal)',
  itemName: 'ExtraMostBestest® Cheese',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-CHS',
  menuWarnings: null,
  orderable: true,
  price: 6.55,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2500,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e2986457-18c4-4f98-bf60-d7f29ca67763.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e2986457-18c4-4f98-bf60-d7f29ca67763.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201106,
  itemCaloriesText: '2500 Cal',
  itemDescription: 'Large round pizza with more Pepperoni and Cheese than our Classic pizza.',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'ExtraMostBestest® Pepperoni (2500 Cal)',
  itemName: 'ExtraMostBestest® Pepperoni',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-PEP',
  menuWarnings: null,
  orderable: true,
  price: 6.55,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2660,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/3af1ea88-eeec-4978-bff4-45c8c9389b6a.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/3af1ea88-eeec-4978-bff4-45c8c9389b6a.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201129,
  itemCaloriesText: '2660 Cal',
  itemDescription: 'Large round with Italian Sausage',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'ExtraMostBestest® Italian Sausage (2660 Cal)',
  itemName: 'ExtraMostBestest® Italian Sausage',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'EMB-SAU',
  menuWarnings: null,
  orderable: true,
  price: 6,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2270,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/7a8ac0b0-3691-4167-856c-d3ec0ede9284.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/7a8ac0b0-3691-4167-856c-d3ec0ede9284.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 201001,
  itemCaloriesText: '2270 Cal',
  itemDescription: 'Large round pizza with Italian Sausage',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Classic Italian Sausage (2270 Cal)',
  itemName: 'Classic Italian Sausage',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'HNR-SAU',
  menuWarnings: null,
  orderable: true,
  price: 5,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2300,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e6a09afe-58ec-4e24-9c52-c92c764cf0d1.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e6a09afe-58ec-4e24-9c52-c92c764cf0d1.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 101001,
  itemCaloriesText: '2300 Cal',
  itemDescription: 'Large round pizza with Pepperoni',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Classic Pepperoni (2300 Cal)',
  itemName: 'Classic Pepperoni',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'HNR-PEP',
  menuWarnings: null,
  orderable: true,
  price: 5.55,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 1950,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/3dfae2da-c3d1-418c-ae5b-fb08511315d3.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/3dfae2da-c3d1-418c-ae5b-fb08511315d3.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 101002,
  itemCaloriesText: '1950 Cal',
  itemDescription: 'Large round pizza with Cheese',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Classic Cheese (1950 Cal)',
  itemName: 'Classic Cheese',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'HNR-CHS',
  menuWarnings: null,
  orderable: true,
  price: 5.55,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}, {
  calories: 2260,
  caloriesRange: '',
  comment: '',
  crustImages: null,
  favoriteId: 0,
  favoriteName: null,
  foodGroup: 'Pizza',
  id: 0,
  images: [{
    imageAltText: '',
    imageType: 'Web_ItemDetailImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e0094c2a-70e4-43b4-a5c7-8fc482baee79.jpg'
  }, {
    imageAltText: '',
    imageType: 'Web_MenuImage',
    imageURL: 'https://mobilestatic.littlecaesars.com/weborderingimages/e0094c2a-70e4-43b4-a5c7-8fc482baee79.jpg'
  }],
  isCustomMenuItem: false,
  itemId: 202011,
  itemCaloriesText: '2260 Cal',
  itemDescription: 'Large round pizza with pepperoni and jalapeño peppers.',
  itemDescriptionWithCalories: null,
  itemNameWithCalories: 'Pepperoni and Jalapeño (2260 Cal)',
  itemName: 'Pepperoni and Jalapeño',
  itemType: 'LRP',
  maxToppings: 0,
  menuItemCode: 'HNR-PJP',
  menuWarnings: null,
  orderable: true,
  price: 7.75,
  selectedCustomOptions: null,
  selectedToppings: null,
  toppingsThresholdCount: 0,
  toppingsThresholdMessage: null,
  servings: ''
}];
exports.mockMenuItems = mockMenuItems;